import React, { Fragment, useEffect } from 'react';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import {
  Box,
  Divider,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import PortalContainer from '@components/PortalContainer';
import LeadInputForm from '@components/Form/CustomerLead/LeadInputForm';
import { LeadCollectionProvider } from '@hooks/useLeadCollection';
import Container from '@common/components/Container/Container';
import { LeadTitle } from '@src/components/Form/CustomerLead/LeadTitle';
import { lucidTheme } from '@components/FullPageLayout/lucidTheme';
import {
  getLanguagePrefix,
  getLocalizedContent as l,
} from '@helpers/languages';
import content from '@components/Form/CustomerLead/LeadInputForm.json';
import { LeadCollectionConfirmationTemplate } from '@views/SelfService/LeadCollector/LeadCollectionConfirmationTemplate';
import colors from '@theme/colors';
import Button from '@common/components/Forms/components/Button';
import leadStaticContent from './LeadCollectionPage.translation.json';
import metadata from './metadata.json';
import SEO from '@common/components/SEO/SEO';

const useStyles = makeStyles(() => ({
  subContent: {
    fontFamily: 'GT America',
    fontSize: '16px',
    color: colors['charcoal'],
    lineHeight: '19px',
    fontWeight: '400',
    paddingBottom: '30px',
    paddingTop: '30px',
  },
}));

export const LeadCollectionTemplate = () => {
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);
  const [isComplete, setIsComplete] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const styles = useStyles();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <PortalContainer isLeadCollection={true}>
      <Container style={{ marginTop: '-40px' }}>
        <ThemeProvider theme={lucidTheme}>
          <SEO
            title={l(metadata.title, language)}
            description={l(metadata.description, language)}
            location={location}
          />
          <LeadCollectionProvider>
            {!isComplete ? (
              <>
                <LeadTitle
                  title={l(content.title, language)}
                  description={l(content.description, language)}
                  subInfo={l(content.subInfo, language)}
                />

                <LeadInputForm setIsComplete={setIsComplete} />
              </>
            ) : (
              <Box style={{ paddingBottom: '30px' }}>
                <LeadTitle
                  title={'Thanks again.'}
                  description={
                    <Fragment>
                      {l(leadStaticContent.confirmationText2, language)}
                      <Link href={'www.lucidmotors.com'}>lucidmotors.com</Link>
                    </Fragment>
                  }
                />
                <Divider variant="middle" />
                <LeadCollectionConfirmationTemplate />
                <Divider variant="middle" />
                <Typography className={styles.subContent}>
                  {l(leadStaticContent.confidentialText, language)}
                </Typography>
                <Button
                  text={'Done'}
                  type={'submit'}
                  height="56px"
                  onClick={() =>
                    window.location.assign(
                      `${window.location.origin}${getLanguagePrefix(language)}`
                    )
                  }
                  dark={false}
                  style={{ width: isMobile ? '100%' : '50%' }}
                />
              </Box>
            )}
          </LeadCollectionProvider>
        </ThemeProvider>
      </Container>
    </PortalContainer>
  );
};
